import cn from 'classnames';
import * as React from 'react';

import { PlaceAdProps } from './types';

export const PlaceAd: React.FC<PlaceAdProps> = props => {
  const { link, containerClassName, buttonContent } = props;

  const handleClick = React.useCallback<VoidFunction>(() => {
    // eslint-disable-next-line no-unused-expressions
    window._headerTrackingEvent?.('add_adv');
  }, []);

  return (
    <a
      className={cn('c-header-create', 'c-header-link', 'c-header-new-link', containerClassName)}
      href={link}
      onClick={handleClick}
    >
      <span className="c-header-create-desktop-text">{buttonContent}</span>
      <div className="c-header-user-back-to-ad-container" id="header-user-back-to-ad-container" />
    </a>
  );
};

PlaceAd.displayName = 'PlaceAd';
